
import { defineComponent } from 'vue'
import { iScorecard, iScorecardCriterion, iKpi, iPerspective, iScorecardTarget } from './Scorecards'
import { AxiosResponse } from 'axios'
import Card from 'primevue/card'
import ScorecardsTable from './ScorecardsTable/ScorecardsTable.vue'
import KnPerspectiveCard from '@/components/UI/KnPerspectiveCard/KnPerspectiveCard.vue'
import descriptor from './ScorecardsDescriptor.json'

const deepcopy = require('deepcopy')

export default defineComponent({
    name: 'scorecards-designer',
    components: { Card, KnPerspectiveCard, ScorecardsTable },
    props: { id: { type: String } },
    data() {
        return {
            descriptor,
            scorecard: null as iScorecard | null,
            nameTouched: false,
            criterias: [] as iScorecardCriterion[],
            kpis: [] as iKpi[],
            touched: false
        }
    },
    computed: {
        saveButtonDisabled(): boolean {
            return !this.scorecard || !this.scorecard.name || this.scorecard.perspectives.length === 0
        }
    },
    watch: {
        async id() {
            await this.loadScorecard()
        }
    },
    async created() {
        await this.loadScorecard()
        await this.loadCriterias()
        await this.loadKpis()
    },
    methods: {
        async loadScorecard() {
            this.$store.commit('setLoading', true)
            if (this.id) {
                await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/kpiee/${this.id}/loadScorecard`).then((response: AxiosResponse<any>) => (this.scorecard = response.data))
            } else {
                this.scorecard = { name: '', description: '', perspectives: [] }
            }
            this.$store.commit('setLoading', false)
        },
        async loadCriterias() {
            this.$store.commit('setLoading', true)
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/domains/listByCode/KPI_SCORECARD_CRITE`).then((response: AxiosResponse<any>) => (this.criterias = response.data))
            this.$store.commit('setLoading', false)
        },
        async loadKpis() {
            this.$store.commit('setLoading', true)
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/kpi/listKpiWithResult`).then((response: AxiosResponse<any>) => (this.kpis = response.data))
            this.$store.commit('setLoading', false)
        },
        async saveScorecard() {
            const tempScorecard = this.getFormattedScorecard()

            const operation = tempScorecard.id ? 'update' : 'create'
            this.$store.commit('setLoading', true)
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/kpiee/saveScorecard`, tempScorecard)
                .then((response: AxiosResponse<any>) => {
                    if (response.data.id && this.scorecard) {
                        this.$store.commit('setInfo', {
                            title: this.$t('common.toast.' + operation + 'Title'),
                            msg: this.$t('common.toast.success')
                        })
                        this.scorecard.id = response.data.id
                        if (operation === 'create') this.$router.push(`/scorecards/${this.scorecard.id}`)
                        this.touched = false
                    }
                })
                .catch(() => {})
            this.$store.commit('setLoading', false)
        },
        getFormattedScorecard() {
            const tempScorecard = deepcopy(this.scorecard)
            // TODO - BE needs to be changed for description
            delete tempScorecard.description

            const fieldToDelete = ['groupedKpis', 'statusColor', 'updated']
            tempScorecard.perspectives?.forEach((perspective: iPerspective) => {
                if (perspective.new) {
                    delete perspective.id
                    delete perspective.new
                }
                fieldToDelete.forEach((field: string) => delete perspective[field])
                perspective.targets?.forEach((target: iScorecardTarget) => {
                    if (target.new) {
                        delete target.id
                        delete target.new
                    }
                    fieldToDelete.forEach((field: string) => delete target[field])
                })
            })

            return tempScorecard
        },
        close() {
            if (!this.touched) {
                this.$router.push(`/scorecards`)
                this.scorecard = null
            } else {
                this.$confirm.require({
                    message: this.$t('common.toast.unsavedChangesMessage'),
                    header: this.$t('common.toast.unsavedChangesHeader'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.touched = false
                        this.$router.push(`/scorecards`)
                        this.scorecard = null
                    }
                })
            }
        }
    }
})
